// extracted by mini-css-extract-plugin
module.exports = {"component":"ContentWrapper_component__JYS_K"};